// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-header {
  background-color: #d9ead3 !important;
}

.info-spacing {
  gap: 4em;
}

.info-padding {
  padding: 12px 24px;
}`, "",{"version":3,"sources":["webpack://./src/style/pumpingstation/expandableAudit.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ;;AAEA;EACI,QAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":[".inner-header {\n    background-color: #d9ead3 !important;\n}\n\n.info-spacing {\n    gap: 4em;\n}\n\n.info-padding {\n    padding: 12px 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
